import { useLocation } from 'react-router-dom';
import EnterEmail from '../components/reset_password/EnterEmail';
import ResetPasswordEmailVerification from '../components/reset_password/ResetPasswordEmailVerification';
import ResetPasswordCreatePassword from '../components/reset_password/ResetPasswordCreatePassword';
import ResetPasswordSuccess from '../components/reset_password/ResetPasswordSuccess';

function ResetPasswordStepWrapper() {
  const location = useLocation();
  const step = location.state?.step || 'enterEmail';

  switch (step) {
    case 'emailVerification':
      return <ResetPasswordEmailVerification />;
    case 'createPassword':
      return <ResetPasswordCreatePassword />;
    case 'success':
      return <ResetPasswordSuccess />;
    default:
      return <EnterEmail />;
  }
}

export default ResetPasswordStepWrapper;
